import { render, staticRenderFns } from "./ReferralPathwaysPieChart.vue?vue&type=template&id=2452c605&scoped=true"
import script from "./ReferralPathwaysPieChart.vue?vue&type=script&lang=js"
export * from "./ReferralPathwaysPieChart.vue?vue&type=script&lang=js"
import style0 from "./ReferralPathwaysPieChart.vue?vue&type=style&index=0&id=2452c605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452c605",
  null
  
)

export default component.exports